import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable, from, firstValueFrom } from "rxjs";
import { ApiResponse } from "../models/api.response";
import { CryptoService } from "./crypto.service";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient, private crypto: CryptoService) { }
  // baseUrl: string = 'https://api-development-dot-mtc-filetransfer.an.r.appspot.com/'; //dev server [from 10.09.2025]
  baseUrl: string = 'https://dev-api.transfercenter.one/'; //dev server
  // baseUrl: string = 'https://mtc-filetransfer.an.r.appspot.com/'; //live server
  // baseUrl: string = 'https://api-live-dot-mtc-filetransfer.an.r.appspot.com/'; //Live Server [From 10.09.2025]
  // baseUrl: string = 'https://api.transfercenter.jp/';
  // baseUrl: string = 'http://localhost:5000/'; //local server

  loadConfig(id:any): Observable<ApiResponse> {
    return from(this.securePost('loadConfig', id));
  }

  getTransferDetails(id:any): Observable<ApiResponse> {
    return from(this.securePost('getFileDataWrtKeyDownload', id));
  }

  getUserDetails(id:any): Observable<ApiResponse> {
    return from(this.securePost('getUserDetailsDownload', id));
  }

  sendOtpForDownload(body:any): Observable<ApiResponse> {
    return from(this.securePost('sendOtp', body));
  }

  checkOtpForDownload(body:any): Observable<ApiResponse> {
    return from(this.securePost('checkOtp', body));
  }

  getFreelancerDetails(brandUrl:any): Observable<ApiResponse> {
    return from(this.securePost('getFreelancerBrandDetailsDownload', brandUrl));
  }

  sendDownloadNotification(body:any): Observable<ApiResponse> {
    return from(this.securePost('sendDownloadNotificationDownload', body));
  }

  sendCollections(composeData:any): Observable<ApiResponse> {
    return from(this.securePost('sendCollectionsDownload', composeData));
  }

  sendMemberOTP(data:any): Observable<ApiResponse> {
    return from(this.securePost('verifyMemberSendOtpDownload', data));
  }

  checkOtpForUpload(body:any): Observable<ApiResponse> {
    return from(this.securePost('verifyMemberCheckOtpDownload', body));
  }

  saveOperationLog(data:any): Observable<ApiResponse> {
    return from(this.securePost('saveOperationLogDownload', data));
  }

  saveOperationLogArray(data:any): Observable<ApiResponse> {
    return from(this.securePost('saveOperationLogSDownload', data));
  }

  downloadTracking(body:any): Observable<ApiResponse> {
    return from(this.securePost('downloadTracking', body));
  }

  certificateStatusChange(body:any): Observable<ApiResponse> {
    return from(this.securePost('certificateStatusChange', body));
  }

  getBrandDetails(brandUrl:any): Observable<ApiResponse> {
    return from(this.securePost('getBrandDetails', brandUrl));
  }

  getLinkAccessCount(body:any): Observable<ApiResponse> {
    return from(this.securePost('getLinkAccessCount', body));
  }
  
  updateDownloadClickCount(body:any): Observable<ApiResponse> {
    return from(this.securePost('updateDownloadClickCount', body));
  }

  // NOTE: GET with no body — left as a plain request. securePost is POST-only,
  // and this endpoint returns non-sensitive geo data. Convert separately if needed.
  getGeoLocation(certificateArn:any): Observable<any>{
    return this.http.get<ApiResponse>(this.baseUrl+'geoip/location');
  }

  //MARK: API Test — end-to-end encrypted (request + response are ciphertext on the wire)
  apiTest(req:any): Observable<any>{
    return from(this.securePost('apiTest', req));
  }

  /**
   * Generic end-to-end encrypted POST:
   *   1. Encrypt `payload` (+ our ephemeral public key) into an opaque envelope.
   *   2. Send the envelope — the Network tab only ever shows ciphertext.
   *   3. Decrypt the server's envelope response with our in-memory private key.
   * Use this for any endpoint you want hidden from browser inspection.
   */
  private async securePost(endpoint: string, payload: any): Promise<any> {
    // Development (ng serve): send/receive plaintext so the request and
    // response parameters are readable in the browser Network tab.
    // Production builds always use the end-to-end encrypted envelope below.

    return firstValueFrom(this.http.post<any>(this.baseUrl + endpoint, payload));

    // if (!environment.production) {
    //   return firstValueFrom(this.http.post<any>(this.baseUrl + endpoint, payload));
    // }

    const envelope = await this.crypto.encryptRequest(payload, this.baseUrl);
    const responseEnvelope = await firstValueFrom(
      this.http.post<any>(this.baseUrl + endpoint, envelope)
    );
    return this.crypto.decryptResponse(responseEnvelope);
  }

}


